import { render, staticRenderFns } from "./IcoChevronRight.vue?vue&type=template&id=05588a0f"
import script from "./IcoChevronRight.vue?vue&type=script&lang=js"
export * from "./IcoChevronRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports